module.exports = __webpack_public_path__ + "media/images/pages/ic-facebook-f39d01e6d6d8a91da3034f07cd2031e2.png";